/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S43_Item_1Inputs */

const es_tyc_obligations_s43_item_1 = /** @type {(inputs: Tyc_Obligations_S43_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata no garantiza la precision, integridad o puntualidad de los Datos Ingestados o Externos.`)
};

const en_tyc_obligations_s43_item_1 = /** @type {(inputs: Tyc_Obligations_S43_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata does not guarantee the accuracy, completeness, or timeliness of Ingested or External Data.`)
};

/**
* | output |
* | --- |
* | "Nexata does not guarantee the accuracy, completeness, or timeliness of Ingested or External Data." |
*
* @param {Tyc_Obligations_S43_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s43_item_1 = /** @type {((inputs?: Tyc_Obligations_S43_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S43_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s43_item_1(inputs)
	return en_tyc_obligations_s43_item_1(inputs)
});
export { tyc_obligations_s43_item_1 as "tyc.obligations.s43_item_1" }